import { CommonModule, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { WebcamModule } from 'ngx-webcam';
import { ButtonNextComponent } from './button-next/button-next.component';
import { ContinuousScrollingComponent } from './components/continuous-scrolling/continuous-scrolling.component';

import { StepBarComponent } from './components/step-bar/step-bar.component';
import { PhoneNumbeMarkrFormatDirective } from './directive-form/phone-number-mark-format.directive';
import { PriceDecimalFormatDirective } from './directive-form/price-decimal-format.directive';
import { ImageLoaderComponent } from './image-loader/image-loader.component';
import { LoadingComponent } from './loading/loading.component';
import { ResultFailedComponent } from './result-failed/result-failed.component';
import { LayoutComponent } from './components/layout/layout.component';
import { JsonEditorPageComponent } from './components/json-editor/json-editor.component'
import { NavigationBarModule } from './navigation-bar/navigation-bar.module'
import { TabsModule } from 'ngx-bootstrap/tabs';
import { NextBackBtnComponent } from './components/next-back-btn/next-back-btn.component'
import { SingleMaskFieldComponent } from './components/mask-field/single-mask-field/single-mask-field.component';
import { DeviceOrderHeaderComponent } from './components/device-order-header/device-order-header.component';
import { NgJsonEditorModule } from 'ang-jsoneditor';
import { NgxLoadingModule, ngxLoadingAnimationTypes } from 'ngx-loading';
import { PopUpComponent } from './pop-up/pop-up.component';
import { PopUpContentComponent } from './pop-up/pop-up-content/pop-up-content.component';
import { GreenButtonComponent } from './button/green-button/green-button.component';
import { PopUpTitleComponent } from './pop-up/pop-up-title/pop-up-title.component';
@NgModule({
  declarations: [
    ButtonNextComponent,
    LoadingComponent,
    StepBarComponent,
    PhoneNumbeMarkrFormatDirective,
    PriceDecimalFormatDirective,
    ResultFailedComponent,
    ContinuousScrollingComponent,
    ImageLoaderComponent,
    LayoutComponent,
    JsonEditorPageComponent,
    NextBackBtnComponent,
    SingleMaskFieldComponent,
    DeviceOrderHeaderComponent,
    PopUpComponent,
    PopUpContentComponent,
    GreenButtonComponent,
    PopUpTitleComponent
  ],
  imports: [
    CommonModule,
    NgxSkeletonLoaderModule,
    WebcamModule,
    ReactiveFormsModule,
    FormsModule,
    NavigationBarModule,
    TabsModule.forRoot(),
    NgJsonEditorModule,
    NgxLoadingModule.forRoot({
      backdropBackgroundColour: 'rgba(0,0,0,0.5)',
      backdropBorderRadius: '3px',
      primaryColour: '#ffffff',
      secondaryColour: '#ffffff',
      tertiaryColour: '#ffffff',
      fullScreenBackdrop: false,
    }),

  ],
  exports: [
    ButtonNextComponent,
    LoadingComponent,
    StepBarComponent,
    PhoneNumbeMarkrFormatDirective,
    PriceDecimalFormatDirective,
    ResultFailedComponent,
    ContinuousScrollingComponent,
    ImageLoaderComponent,
    LayoutComponent,
    JsonEditorPageComponent,
    SingleMaskFieldComponent,
    DeviceOrderHeaderComponent,
    PopUpComponent,
    PopUpContentComponent,
    GreenButtonComponent,
    PopUpTitleComponent
    // NextBackBtnComponent
  ],
  providers: [DecimalPipe],
})
export class SharedModule {}
